import React from "react";
import { DangerIcon } from "../../../../components/icons";
import { MotionModal, ModalCloseButton } from "../../../../components/motion";

const AlertModal = ({
  text = "Please input all required fields (highlighted  in red)",
  handleClose,
  show,
}) => {
  return (
    <>
      <MotionModal
          show={show}
          onClose={handleClose}
          maxWidthClassName="tw:max-w-[500px] tw:lg:max-w-[800px]"
          panelClassName="border-top-danger"
      >
            <div className="tw:flex tw:justify-end tw:px-4 tw:pt-3">
                <ModalCloseButton isInline onClick={handleClose} />
            </div>
            <div
              className="tw:relative tw:flex-1 tw:p-4 tw:my-1 tw:text-center"
              style={{ color: "#ED553B" }}
            >
              <h5 className="tw:mb-6">
                <span className="tw:mr-2">
                  <DangerIcon />
                </span>
                {text}
              </h5>
            </div>
      </MotionModal>
    </>
  );
};

export default AlertModal;
